"use client";

import React from "react";

import dynamic from "next/dynamic";

import Link from "@/components/link";
import HomeSection from "@/components/home-section";

import useMoengageEventTracker from "@/hooks/use-moengage";

import EVENT_NAME from "@/hooks/use-moengage/event-name.json";
import EVENT_ATTRIBUTE from "@/hooks/use-moengage/event-attribute.json";

const ResourceCard = dynamic(() => import("@/components/card/resource"));

const BlogVector = dynamic(() => import("./vectors/blog.svg"));
const FeedVector = dynamic(() => import("./vectors/feed.svg"));
const DailyQuizzesVector = dynamic(() => import("./vectors/daily-quizzes.svg"));
const FreeCoursesVector = dynamic(() => import("./vectors/free-courses.svg"));
const FreeLiveClassesVector = dynamic(
  () => import("./vectors/free-live-classes.svg")
);
const NCERTSummaryVector = dynamic(() => import("./vectors/ncert-summary.svg"));

const resources = [
  {
    icon: FreeCoursesVector,
    url: "/free-courses",
    title: "Free Trial Courses",
    description: "Learn without limits start your journey for free!",
  },
  {
    icon: FreeLiveClassesVector,
    url: "/free-live-classes",
    title: "Free Live Classes",
    description: "Join live, learn free – expert sessions for you.",
  },
  {
    icon: FeedVector,
    url: "/feeds/all/english",
    title: "Feed",
    description: "Stay ahead with daily insights, tips, and updates!",
  },
  {
    icon: NCERTSummaryVector,
    url: "/studyiq-ai",
    title: "NCERT Summary",
    description: "NCERTs made easy – quick, concise, and exam",
  },
  {
    icon: DailyQuizzesVector,
    url: "/dailyquizzes",
    title: "Daily Quizzes",
    description: "Test, learn, repeat – new quizzes every day!",
  },
  {
    icon: BlogVector,
    url: "/articles/current-affairs",
    title: "Blog",
    description: "Smart reads for smart learners boost your prep!",
  },
];

function FreeResources() {
  const trackMoengageEvent = useMoengageEventTracker();

  const handleOnClick = (resource) => () => {
    trackMoengageEvent(EVENT_NAME.FREE_RESOURCE_CLICKED, {
      [EVENT_ATTRIBUTE.RESOURCE_TYPE]: resource.title
        .toLowerCase()
        .replaceAll(" ", "_"),
    });
  };

  return (
    <HomeSection
      title="Get Started"
      containerClassName="bg-grayscale-weak"
      subtitle={
        <>
          <span>Start your journey with</span>
          <span className="text-primary">Free Resources</span>
        </>
      }
      className="grid gap-4 md:gap-x-4.5 grid-cols-2 xl:grid-cols-3"
    >
      {resources.map((resource) => (
        <ResourceCard
          as={Link}
          key={resource.title}
          icon={resource.icon}
          title={resource.title}
          description={resource.description}
          href={resource.url}
          target={resource.url.startsWith("/articles") ? "_blank" : "_self"}
          onClick={handleOnClick(resource)}
        />
      ))}
    </HomeSection>
  );
}

export default FreeResources;
